// Chrome's built-in Google Translate (and similar extensions) rewrites the
// live DOM — text nodes get wrapped in <font> tags — so React's next commit
// can call removeChild/insertBefore against a parent that no longer owns the
// node. That throws NotFoundError and crashes the whole route
// (facebook/react#11538, unfixed as of React 19). Degrade gracefully instead:
// skip the mismatched operation and let React reconcile on the next render.
// Must be imported before anything renders (first import in index.jsx).
let warned = false;
const warnOnce = () => {
  if (warned) return;
  warned = true;
  console.warn(
    '[translateGuard] DOM was mutated outside React (page translation?) — mismatched node operations are being skipped.'
  );
};

if (typeof Node !== 'undefined' && Node.prototype) {
  const { removeChild, insertBefore } = Node.prototype;

  Node.prototype.removeChild = function (child) {
    if (child && child.parentNode !== this) {
      warnOnce();
      return child;
    }
    return removeChild.apply(this, arguments);
  };

  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      warnOnce();
      return newNode;
    }
    return insertBefore.apply(this, arguments);
  };
}
